// src/rentals-api-v3/models/InsuranceType.ts
var InsuranceType = {
  Full: "Full",
  Standard: "Standard",
  Basic: "Basic",
  Partner: "Partner"
};
function instanceOfInsuranceType(value) {
  for (const key in InsuranceType) {
    if (Object.prototype.hasOwnProperty.call(InsuranceType, key)) {
      if (InsuranceType[key] === value) {
        return true;
      }
    }
  }
  return false;
}
function InsuranceTypeFromJSON(json) {
  return InsuranceTypeFromJSONTyped(json, false);
}
function InsuranceTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function InsuranceTypeToJSON(value) {
  return value;
}
export {
  InsuranceType,
  InsuranceTypeFromJSON,
  InsuranceTypeFromJSONTyped,
  InsuranceTypeToJSON,
  instanceOfInsuranceType
};
//# sourceMappingURL=InsuranceType.mjs.map